export const matchCaseInsensitiveArr = (values: unknown[]) => new RegExp(`^${values.join('|')}$`, 'i');
export const caseInsensitiveKeyReplace = (oldObj: Record<string, unknown>, newObj: Record<string, unknown>) => {
  const oldObjCopy = { ...oldObj };
  const keyRegex = matchCaseInsensitiveArr(Object.keys(newObj));
  for (const oldKey in oldObj) {
    if (keyRegex.test(oldKey)) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete oldObjCopy[oldKey];
    }
  }
  return { ...oldObjCopy, ...newObj };
};
